import { render, staticRenderFns } from "./submit-job-work-permit.dialog.vue?vue&type=template&id=c9b3b848"
import script from "./submit-job-work-permit.dialog.ts?vue&type=script&lang=ts&external"
export * from "./submit-job-work-permit.dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports